import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { AudioLines, ArrowUpRight, Play, Pause, SkipBack, SkipForward, Volume2, X } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

const SUNO_URL = "https://suno.com/playlist/338ac864-b869-4e6a-abbd-30ff020223d8";
const ACCENT = "#FACC15";

const TRACKS = [
  { id: "122bd213-f35b-4ca4-837c-977761c89aa0", audio: "122bd213-f35b-4ca4-837c-977761c89aa0", title: "Quiet Focus", duration: "2:17", url: "https://suno.com/song/122bd213-f35b-4ca4-837c-977761c89aa0" },
  { id: "6795af9d-10cf-4c35-877e-be9781b7dc08", audio: "6795af9d-10cf-4c35-877e-be9781b7dc08", title: "Gentle Puzzle Groove", duration: "1:57", url: "https://suno.com/song/6795af9d-10cf-4c35-877e-be9781b7dc08" },
  { id: "811b067e-e681-457a-8c74-301d0679a8c7", audio: "811b067e-e681-457a-8c74-301d0679a8c7", title: "Word Hunt", duration: "0:40", url: "https://suno.com/song/811b067e-e681-457a-8c74-301d0679a8c7" },
  { id: "7eed3ade-40dc-4380-8345-8b12e087bd76", audio: "7eed3ade-40dc-4380-8345-8b12e087bd76", title: "Still Waters", duration: "2:54", url: "https://suno.com/song/7eed3ade-40dc-4380-8345-8b12e087bd76" },
  { id: "6176ecbc", audio: "6176ecbc-4698-4735-b8a5-60da7a9010bc", title: "Parole In Tondo", duration: "1:12", url: SUNO_URL },
  { id: "62fc8cc7", audio: "62fc8cc7-adcd-4f98-9a87-cf30dfb24b4a", title: "Parole in Sospeso", duration: "2:24", url: SUNO_URL },
  { id: "a1fb8d35", audio: "a1fb8d35-7095-46f4-8ec8-f247a1de3649", title: "Word Vault", duration: "0:30", url: SUNO_URL },
  { id: "f81354d9", audio: "f81354d9-18a1-47e3-a066-a154a79e3ead", title: "Puzzle of the Heart", duration: "1:44", url: SUNO_URL },
  { id: "4e86ec65", audio: "4e86ec65-95ca-408f-ad81-1d6a0d0aea02", title: "Voice orchestra", duration: "2:13", url: SUNO_URL },
  { id: "9e157b61", audio: "9e157b61-9bbf-4cf8-9948-1b51c59aa0f2", title: "Ruota", duration: "2:49", url: SUNO_URL },
  { id: "d669e53b", audio: "d669e53b-eaee-4be1-a018-96d0b4909e75", title: "Quando la Sanità Vacilla", duration: "4:03", url: SUNO_URL },
  { id: "3f82ff5f", audio: "3f82ff5f-86c3-4b88-9e33-7bfc64fe11d9", title: "Democracy Is Dying", duration: "2:43", url: SUNO_URL },
  { id: "4ae5918b", audio: "4ae5918b-96f9-4547-a436-46a0001ad776", title: "Berlino la città del peccato", duration: "5:07", url: SUNO_URL },
  { id: "e15eafb3", audio: "e15eafb3-34ee-4f30-bbdf-17961e552e88", title: "Per chi aspetta meteoriti", duration: "2:42", url: SUNO_URL },
  { id: "54a2bb10", audio: "54a2bb10-1394-4b7d-86f8-b525f9036740", title: "Fastidiosamente Utile", duration: "3:47", url: SUNO_URL },
  { id: "3aa6cea0", audio: "3aa6cea0-dd0c-486c-b241-ee0c04618003", title: "Luci e Colori +", duration: "4:04", url: SUNO_URL },
  { id: "a22e8871", audio: "a22e8871-0c4b-41f3-b03b-ce409950fea7", title: "Ritrovarsi", duration: "3:24", url: SUNO_URL },
  { id: "68c0aa02", audio: "68c0aa02-f3f0-4705-b749-cdcee3cc7ec9", title: "Il referendum del No", duration: "3:35", url: SUNO_URL },
  { id: "b31a0cc2", audio: "b31a0cc2-d27b-49f3-b8e5-2dda145f0d05", title: "Analog Warmth", duration: "3:00", url: "https://suno.com/song/b31a0cc2-d27b-49f3-b8e5-2dda145f0d05" },
  { id: "ebba62c7", audio: "ebba62c7-a65e-40d5-b070-45a84f445093", title: "Equilibrium", duration: "3:00", url: "https://suno.com/song/ebba62c7-a65e-40d5-b070-45a84f445093" },
  { id: "c6a93fad", audio: "c6a93fad-2cab-43dd-805c-485ed85d44a1", title: "Borrowed Halo", duration: "3:00", url: "https://suno.com/song/c6a93fad-2cab-43dd-805c-485ed85d44a1" },
  { id: "45d3254d", audio: "45d3254d-b861-4ac7-9466-c22051877157", title: "Glass Between Us", duration: "3:00", url: "https://suno.com/song/45d3254d-b861-4ac7-9466-c22051877157" },
  { id: "ba202451", audio: "ba202451-44cb-4354-a734-0c76a237cc55", title: "Focal Flow", duration: "4:09", url: "https://suno.com/song/ba202451-44cb-4354-a734-0c76a237cc55" },
  { id: "2d58091c", audio: "2d58091c-6ef4-46e2-9bbc-c639055d8ae4", title: "Convergence in Key", duration: "3:00", url: "https://suno.com/song/2d58091c-6ef4-46e2-9bbc-c639055d8ae4" },
];

const MusicSection = () => {
  const { t } = useLanguage();
  const [playing, setPlaying] = useState(null);
  const [progress, setProgress] = useState(0);
  const [volume, setVolume] = useState(() => {
    const v = parseFloat(localStorage.getItem("fc-volume"));
    return Number.isNaN(v) ? 1 : v;
  });
  const [lastTrack, setLastTrack] = useState(() => {
    const v = parseInt(localStorage.getItem("fc-track"), 10);
    return Number.isNaN(v) ? null : v;
  });
  const audioRef = useRef(null);

  useEffect(() => () => audioRef.current?.pause(), []);

  useEffect(() => {
    if (audioRef.current) audioRef.current.volume = volume;
    localStorage.setItem("fc-volume", String(volume));
  }, [volume]);

  const play = (i) => {
    audioRef.current?.pause();
    const audio = new Audio(`/assets/music/${TRACKS[i].audio}.m4a`);
    audio.volume = volume;
    audioRef.current = audio;
    setProgress(0);
    audio.ontimeupdate = () => {
      if (audio.duration) setProgress((audio.currentTime / audio.duration) * 100);
    };
    audio.onended = () => {
      if (i < TRACKS.length - 1) {
        play(i + 1);
      } else {
        setPlaying(null);
        setProgress(0);
      }
    };
    audio.play().catch(() => setPlaying(null));
    setPlaying(i);
    setLastTrack(i);
    localStorage.setItem("fc-track", String(i));
  };

  const toggle = (i) => {
    if (playing === i) {
      audioRef.current?.pause();
      setPlaying(null);
      return;
    }
    play(i);
  };

  return (
    <section className="border-t border-white/10 px-6 py-24 md:px-12" data-testid="music-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 md:grid-cols-12">
        <Reveal className="md:col-span-4">
          <div
            role="button"
            tabIndex={0}
            onClick={() => toggle(playing ?? lastTrack ?? 0)}
            onKeyDown={(e) => {
              if (e.key === "Enter") toggle(playing ?? lastTrack ?? 0);
            }}
            className="group relative block cursor-pointer"
            data-testid="music-cover-play"
            aria-label={playing !== null ? "Pausa" : "Riproduci la playlist"}
          >
            <div className="pointer-events-none absolute -inset-6 rounded-full blur-3xl" style={{ backgroundColor: `${ACCENT}1A` }} />
            <img
              key={playing ?? lastTrack ?? "playlist"}
              src={playing !== null ? `https://cdn2.suno.ai/image_${TRACKS[playing].audio}.jpeg` : lastTrack !== null ? `https://cdn2.suno.ai/image_${TRACKS[lastTrack].audio}.jpeg` : "/assets/suno-cover.jpeg"}
              alt={playing !== null ? `Copertina di ${TRACKS[playing].title}` : lastTrack !== null ? `Copertina di ${TRACKS[lastTrack].title}` : "Copertina playlist Suno"}
              data-testid="music-big-cover"
              className="cover-in relative aspect-square w-full max-w-sm rounded-2xl border border-white/15 object-cover"
            />
            {playing !== null && (
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 rounded-b-2xl bg-gradient-to-t from-black/90 via-black/50 to-transparent p-5 pt-14" data-testid="music-now-playing">
                <div className="min-w-0">
                  <p className="font-mono text-[10px] uppercase tracking-[0.3em]" style={{ color: ACCENT }}>{t.music.nowPlaying}</p>
                  <p className="mt-1 truncate font-display text-xl font-bold tracking-tight">{TRACKS[playing].title}</p>
                </div>
                <div className="flex shrink-0 gap-2">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (playing > 0) play(playing - 1);
                    }}
                    disabled={playing === 0}
                    data-testid="music-prev-button"
                    aria-label="Brano precedente"
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-white/25 text-white transition-colors duration-300 hover:border-white disabled:opacity-30"
                  >
                    <SkipBack className="h-4 w-4" />
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (playing < TRACKS.length - 1) play(playing + 1);
                    }}
                    disabled={playing === TRACKS.length - 1}
                    data-testid="music-next-button"
                    aria-label="Brano successivo"
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-white/25 text-white transition-colors duration-300 hover:border-white disabled:opacity-30"
                  >
                    <SkipForward className="h-4 w-4" />
                  </button>
                  <span
                    className="ml-1 hidden items-center gap-2 sm:flex"
                    onClick={(e) => e.stopPropagation()}
                    onPointerDown={(e) => e.stopPropagation()}
                  >
                    <Volume2 className="h-4 w-4 text-white/80" />
                    <input
                      type="range"
                      min="0"
                      max="1"
                      step="0.05"
                      value={volume}
                      onChange={(e) => setVolume(parseFloat(e.target.value))}
                      data-testid="music-volume-slider"
                      aria-label="Volume"
                      className="h-1 w-20 cursor-pointer"
                      style={{ accentColor: ACCENT }}
                    />
                  </span>
                </div>
              </div>
            )}
            <span className="absolute inset-0 flex items-center justify-center rounded-2xl bg-black/30 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              <span className="flex h-16 w-16 items-center justify-center rounded-full" style={{ backgroundColor: ACCENT, color: "#050505" }}>
                {playing !== null ? <Pause className="h-7 w-7" /> : <Play className="h-7 w-7" />}
              </span>
            </span>
          </div>
        </Reveal>
        <Reveal delay={0.12} className="md:col-span-8">
          <p className="mb-4 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em]" style={{ color: ACCENT }}>
            <AudioLines className="h-4 w-4" />
            {t.music.kicker}
          </p>
          <h2 className="max-w-xl font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl" data-testid="music-title">
            {t.music.title}
          </h2>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-muted2 md:text-base">{t.music.desc}</p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-muted2 md:text-base" data-testid="music-more">
            {t.music.morePre}
            <Link to="/oltre" data-testid="music-blog-link" className="underline underline-offset-4 transition-colors duration-300 hover:text-white" style={{ color: ACCENT }}>
              {t.music.moreLink}
            </Link>
            {t.music.morePost}
          </p>
          <p className="mt-4 font-mono text-xs uppercase tracking-widest text-muted2" data-testid="music-songs">{t.music.songs}</p>
          <ul className="mt-8 max-h-[26rem] overflow-y-auto border-t border-white/10 pr-2" data-testid="music-tracks" data-lenis-prevent>
            {TRACKS.map((tr, i) => {
              const isPlaying = playing === i;
              return (
                <li key={tr.id} className="border-b border-white/10">
                  <div className="flex items-center gap-4 py-3.5">
                    <button
                      onClick={() => toggle(i)}
                      data-testid={`music-play-${i}`}
                      aria-label={`${isPlaying ? "Pausa" : "Ascolta"} ${tr.title}`}
                      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors duration-300"
                      style={{
                        borderColor: `${ACCENT}66`,
                        color: isPlaying ? "#050505" : ACCENT,
                        backgroundColor: isPlaying ? ACCENT : "transparent",
                      }}
                    >
                      {isPlaying ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4" />}
                    </button>
                    <img
                      src={`https://cdn2.suno.ai/image_${tr.audio}.jpeg`}
                      alt={`Copertina di ${tr.title}`}
                      loading="lazy"
                      className="h-9 w-9 shrink-0 rounded-lg border border-white/15 object-cover"
                    />
                    <a
                      href={tr.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`music-track-${i}`}
                      className="flex-1 text-sm font-medium transition-colors duration-300 hover:text-white md:text-base"
                    >
                      {tr.title}
                    </a>
                    {isPlaying && (
                      <span className="flex h-4 shrink-0 items-end gap-[3px]" data-testid={`music-eq-${i}`} aria-hidden="true">
                        {[0.9, 0.6, 1.1, 0.75].map((d, bi) => (
                          <span
                            key={bi}
                            className="eq-bar h-full w-[3px] rounded-full"
                            style={{ backgroundColor: ACCENT, animationDuration: `${d}s` }}
                          />
                        ))}
                      </span>
                    )}
                    <span className="font-mono text-xs text-muted2">{tr.duration}</span>
                  </div>
                  {isPlaying && (
                    <div
                      className="mb-3.5 h-0.5 w-full cursor-pointer bg-white/10 transition-all duration-150 hover:h-1.5"
                      data-testid={`music-progress-${i}`}
                      onClick={(e) => {
                        const rect = e.currentTarget.getBoundingClientRect();
                        const ratio = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
                        if (audioRef.current?.duration) {
                          audioRef.current.currentTime = ratio * audioRef.current.duration;
                          setProgress(ratio * 100);
                        }
                      }}
                    >
                      <div className="h-full" style={{ width: `${progress}%`, backgroundColor: ACCENT, transition: "width 200ms linear" }} />
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
          <a
            href={SUNO_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="music-suno-button"
            className="group mt-8 inline-flex items-center gap-2 rounded-full px-7 py-3.5 font-mono text-xs font-bold uppercase tracking-widest text-black transition-transform duration-300 hover:scale-105"
            style={{ backgroundColor: ACCENT }}
          >
            {t.music.cta}
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </Reveal>
      </div>

      {playing !== null && (
        <div className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-black/85 backdrop-blur-xl" data-testid="mini-player">
          <div className="h-0.5 w-full bg-white/10">
            <div className="h-full" style={{ width: `${progress}%`, backgroundColor: ACCENT, transition: "width 200ms linear" }} />
          </div>
          <div className="mx-auto flex max-w-7xl items-center gap-4 px-6 py-3 md:px-12">
            <img
              src={`https://cdn2.suno.ai/image_${TRACKS[playing].audio}.jpeg`}
              alt=""
              className="h-10 w-10 shrink-0 rounded-lg border border-white/15 object-cover"
            />
            <div className="min-w-0 flex-1">
              <p className="truncate font-display text-sm font-bold" data-testid="mini-player-title">{TRACKS[playing].title}</p>
              <p className="font-mono text-[10px] uppercase tracking-widest text-muted2">DottorFabio · Suno</p>
            </div>
            <button
              onClick={() => playing > 0 && play(playing - 1)}
              disabled={playing === 0}
              aria-label="Brano precedente"
              data-testid="mini-player-prev"
              className="hidden h-9 w-9 items-center justify-center rounded-full text-white transition-colors duration-300 hover:text-white/70 disabled:opacity-30 sm:flex"
            >
              <SkipBack className="h-4 w-4" />
            </button>
            <button
              onClick={() => toggle(playing)}
              aria-label="Pausa"
              data-testid="mini-player-toggle"
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full"
              style={{ backgroundColor: ACCENT, color: "#050505" }}
            >
              <Pause className="h-4 w-4" />
            </button>
            <button
              onClick={() => playing < TRACKS.length - 1 && play(playing + 1)}
              disabled={playing === TRACKS.length - 1}
              aria-label="Brano successivo"
              data-testid="mini-player-next"
              className="hidden h-9 w-9 items-center justify-center rounded-full text-white transition-colors duration-300 hover:text-white/70 disabled:opacity-30 sm:flex"
            >
              <SkipForward className="h-4 w-4" />
            </button>
            <button
              onClick={() => toggle(playing)}
              aria-label="Chiudi il player"
              data-testid="mini-player-close"
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-muted2 transition-colors duration-300 hover:text-white"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default MusicSection;
